import _typeof from "@babel/runtime/helpers/esm/typeof";
import { isObject, isArray, isUndef } from '@autobest-ui/utils';
function customForEach(obj, fn) {
  if (isUndef(obj)) {
    return;
  }
  if (_typeof(obj) !== 'object') {
    obj = [obj];
  }
  if (isArray(obj)) {
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}
export default function merge() {
  var args = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }
  var result = {};
  function assignValue(val, key) {
    if (isObject(result[key]) && isObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else if (!isUndef(val)) {
      result[key] = val;
    }
  }
  for (var i = 0, l = args.length; i < l; i++) {
    customForEach(args[i], assignValue);
  }
  return result;
}